<template>
  <div class="add-matrix">
    <div class="file-block">
      <div v-show="!selectedMatrix" class="set-file-btn">
        <label for="file-input-matrix" class="file-label">Добавить ИМ</label>
        <input id="file-input-matrix" type="file" ref="fileInputMatrix" accept=".xlsx, .xls" class="file-input-matrix" @change="handleFileChange" />
      </div>
      <p v-if="selectedMatrix" class="file-name">{{selectedMatrix.substring(0, 15)}}...</p>
    </div>
    
    <div>
      <button 
      v-if="selectedMatrix" 
      @click="submitMatrix" 
      class="upload-button"
      :disabled="uploading">{{ uploading ? 'Отправка…' : 'Отправить' }}</button>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import ApiConnector from '@/backend/apiModels/userApi'
import { createToaster } from "@meforma/vue-toaster";

export default {
  name: 'CustomerMatrix',
  props:['customerId'],
  setup(props) {
    const fileInputMatrix = ref(null);
    const selectedMatrix = ref('');
    const uploading = ref(false)
    const api = new ApiConnector()
    const toaster = createToaster()

    const handleFileChange = () => {
      const file = fileInputMatrix.value.files[0];
      if (file) {
        selectedMatrix.value = file.name;
      } else {
        selectedMatrix.value = '';
      }
    };

    
    const submitMatrix = async () => {
      const file = fileInputMatrix.value.files[0];
      if (!file || uploading.value) return
      uploading.value = true
      try {
        const { response, request } = api.updateCustomerTable('customers/matrix/'+props.customerId,file);
        await request();
        if (response.value?.msg) {
          toaster.success(response.value.msg)
        } else {
          toaster.error('Не удалось загрузить ИМ')
        }
      } catch {
        toaster.error('Ошибка загрузки ИМ')
      } finally {
        uploading.value = false
        if (fileInputMatrix.value) fileInputMatrix.value.value = ''
        selectedMatrix.value = ''
      }
    }

    return {
      fileInputMatrix,
      selectedMatrix,
      uploading,
      handleFileChange,
      submitMatrix,
    };
  },
};
</script>

<style scoped>
.add-matrix {
  display: flex;
  flex-direction: column;
}

.file-block{
  display: flex;
  align-items: center;
}

.file-label {
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.file-label:hover {
  background-color: #0056b3;
}

.file-label:active {
  background-color: #00499a;
}

.file-label:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
}

.file-input-matrix {
  display: none;
}

.file-name{
  margin-left: 10px;
}

.upload-button {
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.upload-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.upload-button:hover {
  background-color: #0056b3;
}

.upload-button:active {
  background-color: #00499a;
}

.upload-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
}

</style>
